<template>
	<el-dialog title="轮胎更换记录详情" v-model="isDetailRecord" width="60%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<!-- <p class="platTitle">基础信息</p> -->
			<div class="info-input-container">
				<div class="flex flex-y-start flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>车牌号码</span>
						</div>
						<el-input v-model="vemrVehNo" class="platItemRigth" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>轮胎品牌</span>
						</div>
						<el-input v-model="vemiBrand" class="platItemRigth" placeholder="请输入轮胎品牌" readonly/>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>轮胎规格</span>
						</div>
						<el-input v-model="vemiSpecifications" class="platItemRigth" placeholder="请输入轮胎规格(如185/65)" readonly/>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>更换数量</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="vemiCount" placeholder="请输入更换数量" readonly/>
							<div class="link-box">
								<i class="el-icon-link"></i>条
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>更换时日期</span>
						</div>
						<el-input v-model="vemrUpdateDate" class="platItemRigth" readonly />
						<!-- <div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="vemrUpdateDate" type="datetime" :clearable="false"
								placeholder="请选择日期" @change="getvemrUpdateDate">
							</el-date-picker>
						</div> -->
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>更换时里程</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="vemrUpdateMiles" placeholder="请输入里程数" readonly/>
							<div class="link-box">
								<i class="el-icon-link"></i>公里
							</div>
						</div>
					</div>

					<!-- <div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>更换里程周期</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="whAddr" placeholder="请输入里程" />
							<div class="link-box">
								<i class="el-icon-link"></i>公里
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>提前提醒里程</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="whAddr" placeholder="请输入里程" />
							<div class="link-box">
								<i class="el-icon-link"></i>公里
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>更换时间周期</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="whAddr" placeholder="请输入月数" />
							<div class="link-box">
								<i class="el-icon-link"></i>月
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>提前提醒时间</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="whAddr" placeholder="请输入里程" />
							<div class="link-box">
								<i class="el-icon-link"></i>天
							</div>
						</div>
					</div> -->
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>总金额</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text" class="custom-input"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;"
								v-model="vemrMoney" placeholder="请输入金额" readonly/>
							<div class="link-box">
								<i class="el-icon-link"></i>元
							</div>
						</div>
					</div>
					<!-- <div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>更换经办人</span>
						</div>
						<el-input v-model="vemrCreator" class="platItemRigth" placeholder="请输入" />
					</div> -->
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>支付状态</span>
						</div>
						<el-input v-model="vemrPayStatusValue" class="platItemRigth" readonly />
						<!-- <div class="flex platItemRigth flex-y-center">
							<el-select v-model="vemrPayStatus" placeholder="请选择支付状态">
								<el-option label="未支付" :value="0" />
								<el-option label="已支付" :value="1" />
							</el-select>
						</div> -->
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>支付日期</span>
						</div>
						<el-input v-model="vemrPayDate" class="platItemRigth" readonly />
						<!-- <div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="vemrPayDate" type="datetime" :clearable="false" placeholder="请选择日期"
								@change="getvemrPayDate">
							</el-date-picker>
						</div> -->
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>支付账户</span>
						</div>
						<el-input v-model="vemrPayAccount" class="platItemRigth" placeholder="请输入支付账户" readonly/>
					</div>
					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>更换原因</span>
						</div>
						<el-input v-model="vemrDescribe" type="textarea" class="platItemRigth2" placeholder="请输入"
							:rows="5" readonly/>
					</div>
					
					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>更换凭证</span>
						</div>
						<div class="rpic_img_box">
							<template v-if="vemrProofUrl.length > 0">
								<div class="upRpic_icon_item" v-for="(item, index) in vemrProofUrl" :key="index">
									<img :src="item" alt="" style="width: auto; height: 60%" v-viewer/>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>


			<div class="footer_btn_warp">
				<template v-if="pageType != 'detail'">
					<div class="cancle_btn" v-on:click="closeModal()">取消</div>
					<!-- <div class="confirm_btn" v-on:click="submit()">确定</div> -->
				</template>
				<template v-else>
					<div class="cancle_btn" v-on:click="closeModal()">关闭</div>
				</template>
			</div>
			<!-- 
			<Address ref="addressRef" v-if="isAddress" @getAddressData="getAddressData" /> -->
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		parseTime,
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	// import Address from "./address";
	export default defineComponent({
		components: {
			// Address
		},
		name: "Add",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};

			onMounted(() => {
				nextTick(() => {
					getVehicleList(); //获取车辆
					//getProvinceList(); //获取省份
					//getProviderList(); //获取客商
				});
			});
			const data = reactive({
				isDetailRecord: false,
				provinceList: [], //省
				cityList: [], //市
				areaList: [], //区县
				ProviderList: [], //所属客商
				vehHeadList: [],
				lorVehicleId: null, //运力车辆
				isAddress: false,
				addType: "",

				vemrId: "",
				vemrVehId: "",
				vemrVehNo: "",
				vemrType: "0",
				vemrUpdateDate: "",
				vemrUpdateMiles: "",
				vemrTitle: "",
				vemrMoney: "",
				vemrDescribe: "",
				vemrRemark: "",
				vemrProofUrl: [], //凭证图片
				vemrPayAccount: "",
				vemrPayDate: null,
				vemrPayStatus: 0,
				vemrPayStatusValue: "",
				vemrCreator: "",
				vemiType: "0",
				vemiName: "轮胎更换",
				vemiBrand: "",
				vemiSpecifications: "",
				vemiPrice: 0,
				vemiCount: 0,
				vemiPriceSum: 0,
				vemiRemark: ""
			});
			//重置数据
			const init = (id) => {
				data.isDetailRecord = true;
				data.vemrId = id;
				data.vemrVehId = null;
				data.vemrVehNo = "";
				data.vemrType = "0";
				data.vemrUpdateDate = "";
				data.vemrUpdateMiles = "";
				data.vemrTitle = "";
				data.vemrMoney = "";
				data.vemrDescribe = "";
				data.vemrRemark = "";
				data.vemrProofUrl = [];
				data.vemrPayAccount = "";
				data.vemrPayDate = null;
				data.vemrPayStatus = 0;
				data.vemrPayStatusValue = "";
				data.vemrCreator = "";
				data.vemiType = "0";
				data.vemiName = "轮胎更换";
				data.vemiBrand = "";
				data.vemiSpecifications = "";
				data.vemiPrice = 0;
				data.vemiCount = 0;
				data.vemiPriceSum = 0;
				data.vemiRemark = "";

				data.addType = "";
				data.vehHeadList = [];
				data.lorVehicleId = null; //运力车辆
				
				getRecordData();
			};
			
			//获取列表数据
			const getRecordData = async () => {
				let params = {
					vemrId: data.vemrId,
				};
				const r = await proxy.$http.get(apiObj.vehMaintenanceRecedit, params);
				if (r.code === 0 || r.respCode === '0000') {
					data.vemrVehId = r.vehMaintenanceRec.vemrVehId;
					data.vemrVehNo = r.vehMaintenanceRec.vehNo;
					data.vemrType = r.vehMaintenanceRec.vemrType;
					data.vemrUpdateDate = r.vehMaintenanceRec.vemrUpdateDate;
					data.vemrUpdateMiles = r.vehMaintenanceRec.vemrUpdateMiles;
					data.vemrTitle = r.vehMaintenanceRec.vemrTitle;
					data.vemrMoney = r.vehMaintenanceRec.vemrMoney;
					data.vemrDescribe = r.vehMaintenanceRec.vemrDescribe;
					data.vemrRemark = r.vehMaintenanceRec.vemrRemark;
					data.vemrProofUrl = r.vehMaintenanceRec.proofPicList;
					data.vemrPayAccount = r.vehMaintenanceRec.vemrPayAccount;
					data.vemrPayDate = r.vehMaintenanceRec.vemrPayDate;
					data.vemrPayStatus =r.vehMaintenanceRec.vemrPayStatus;
					data.vemrCreator = r.vehMaintenanceRec.vemrCreator;
					data.vemiType = r.vehMaintenanceRec.itemList[0].vemiType;
					data.vemiName = r.vehMaintenanceRec.itemList[0].vemiName;
					data.vemiBrand = r.vehMaintenanceRec.itemList[0].vemiBrand;
					data.vemiSpecifications = r.vehMaintenanceRec.itemList[0].vemiSpecifications;
					data.vemiPrice = r.vehMaintenanceRec.itemList[0].vemiPrice;
					data.vemiCount = r.vehMaintenanceRec.itemList[0].vemiCount;
					data.vemiPriceSum = r.vehMaintenanceRec.itemList[0].vemiPriceSum;
					data.vemiRemark = r.vehMaintenanceRec.itemList[0].vemiRemark;
					
					if (data.vemrPayStatus == '0') {
						data.vemrPayStatusValue = "未支付";
					} else if (data.vemrPayStatus == '1') {
						data.vemrPayStatusValue = "已支付";
					} else {
						data.vemrPayStatusValue = "";
					}
					
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			const dialogClosedHandle = () => {
				data.isDetailRecord = false;
			};
			const closeModal = () => {
				data.isDetailRecord = false;
			};
			const submit = async () => {
				if (data.vemrVehId == "") {
					proxy.$message.error("请填写车辆");
					return;
				}
				if (data.vemrUpdateDate == "") {
					proxy.$message.error("请填写更换时时间");
					return;
				}
				if (data.vemrUpdateMiles == "") {
					proxy.$message.error("请填写更换时里程");
					return;
				}
				if (data.vemiBrand == "") {
					proxy.$message.error("请填写轮胎品牌");
					return;
				}
				if (data.vemiSpecifications == "") {
					proxy.$message.error("请填写轮胎规格");
					return;
				}
				if (data.vemrMoney == "") {
					proxy.$message.error("请填写总金额");
					return;
				}
				if (data.vemrDescribe == "") {
					proxy.$message.error("请填写更换内容");
					return;
				}
				
				data.vemrTitle="轮胎更换";

				let params = {
					vemrId: data.vemrId,
					vemrType: data.vemrType,
					vemrUpdateDate: data.vemrUpdateDate,
					vemrUpdateMiles: data.vemrUpdateMiles,
					vemrTitle: data.vemrTitle,
					vemrMoney: data.vemrMoney,
					vemrDescribe: data.vemrDescribe,
					vemrRemark: data.vemrRemark,
					vemrPayAccount: data.vemrPayAccount,
					vemrPayDate: data.vemrPayDate,
					vemrPayStatus: data.vemrPayStatus,
					proofPicList: data.vemrProofUrl,
					itemList: [{
						vemiType: data.vemiType,
						vemiName: data.vemiName,
						vemiBrand: data.vemiBrand,
						vemiSpecifications: data.vemiSpecifications,
						vemiPrice: data.vemiPrice,
						vemiCount: data.vemiCount,
						vemiPriceSum: data.vemiPriceSum,
						vemiRemark: data.vemiRemark
					}]
				}

				const r = await proxy.$http.post(apiObj.vehMaintenanceRecupdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();

					data.isDetailRecord = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};

			//选择运力车辆
			const getVehicleList = async () => {
				let params = {
					searchWord: "",
					page: 1,
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.vehicleList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.rows;
				}
			};

			//获取所属客商
			const getProviderList = async () => {
				let params = {
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.ProviderList = res.rows;
				}
			};
			
			const getvemrPayDate = (ev) => {
				data.vemrPayDate = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.vemrPayDate);
			};

			const getvemrUpdateDate = (ev) => {
				data.vemrUpdateDate = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.vemrUpdateDate);
			};
			
			//删除图片
			const delImg = (index) => {
				let url = data.vemrProofUrl[index];
				if (url.indexOf("https://") !== -1) {
					removeImgUrl(url);
				}
				data.vemrProofUrl.splice(index, 1);
			};
			
			//上传图片
			const upLoadBase64uploadToOSS = async (imageUrl, type) => {
				await proxy.$http.post("/api/ossUpload/base64Json", {
						name: imageUrl,
						value: "123",
					})
					.then((res) => {
						// if(res.)
						data[type] = res;
					});
			};
			
			const uploadvemrProofUrl = (file) => {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;
				if (isLt2M == false) {
					proxy.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (data.vemrProofUrl.length >= 5) {
						proxy.$message.error("最多上传5张");
						return false;
					}
					proxy.$http
						.post("/api/ossUpload/base64Json", {
							name: imageUrl,
							value: "123",
						})
						.then((res) => {
							data.vemrProofUrl.push(res);
						});
				});
			};
			
			//删除图片
			const removeImgUrl = async (imageUrl) => {
				await proxy.$http.post("/biz/bdzl/rptInfo/removeUrl", {
						url: imageUrl
					})
					.then((res) => {});
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit,
				uniqueArr,
				getvemrUpdateDate,
				getvemrPayDate,
				delImg,
				uploadvemrProofUrl,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}



	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 10px;
	}

	.platItemLeft {
		min-width: 90px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth2 {
		width: 100%;
		padding-left: 20px;
		padding-right: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.input_box {
		margin-left: 20px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 77%;
		height: 35px;
		padding-left: 0px;
	}

	.link-box {
		margin-right: 10px;
		font-size: 14px;
		color: #606266;
		cursor: pointer;
		width: 60px;
		text-align: right;
	}

	.custom-input {
		color: #606266;
		/* 输入文本颜色 */
	}

	.custom-input::placeholder {
		color: #c0c4cc;
		/* placeholder文本颜色 */
	}
	
	.rpic_img_box {
		width: 100%;
		height: 150px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		margin-right: 20px;
		display: flex;
		flex-wrap: wrap;
	}
	
	.upRpic_icon_item {
		margin-top: 10px;
		width: 125px;
		height: 125px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}
	
	.upRpic_icon {
		width: 20px;
		height: 20px;
	}
</style>